import { ApolloError, QueryResult } from '@apollo/client';
import * as React from 'react';
import { Pmc, Query, QueryParkZoneArgs } from 'types/generatedSchemaTypes';

export type LongTermParkingContextProps = {
  selectedPmcs?: Pmc[];
  loading: boolean;
  error: ApolloError | undefined;
  parkingZoneResult?: QueryResult<Query, QueryParkZoneArgs>;
};

const LongTermParkingContext = React.createContext<LongTermParkingContextProps>(
  {
    selectedPmcs: undefined,
    loading: false,
    error: undefined,
    parkingZoneResult: undefined,
  }
);

export default LongTermParkingContext;
